export const getWashedUserRoles = (roles: string[] = []) => {
  const washedRoles = roles?.map((role) => {
    if (role.match(/RADGIVARE-(.*)/)) {
      return 'RADGIVARE'
    }
    return role
  })
  return washedRoles ?? []
}
